var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sms"},[_c('verify-header'),_c('vk-mode-layout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }